import React, { useState } from 'react';
import './Header.scss';

interface HeaderProps {
  onToggleSidebar: () => void;
  sidebarCollapsed: boolean;
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar, sidebarCollapsed, onLogout }) => {
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const adminUser = JSON.parse(localStorage.getItem('admin_user') || '{}');

  return (
    <>
      {/* Overlay to close dropdown when clicking outside */}
      {userDropdownOpen && (
        <div 
          className="dropdown-overlay"
          onClick={() => setUserDropdownOpen(false)}
        />
      )}
      <header className="admin-header">
        <div className="header-left">
          <button 
            className="sidebar-toggle"
            onClick={onToggleSidebar}
            title={sidebarCollapsed ? 'Išskleisti meniu' : 'Suskleisti meniu'}
          >
            <span className={`hamburger ${sidebarCollapsed ? 'collapsed' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>

        <div className="header-right">
          <div className="user-menu">
            <button 
              className="user-button"
              onClick={() => setUserDropdownOpen(!userDropdownOpen)}
            >
              <div className="user-avatar">
                {adminUser.name?.charAt(0) || 'A'}
              </div>
              <div className="user-info">
                <span className="user-name">{adminUser.name || 'Admin User'}</span>
                <span className="user-role">Administratorius</span>
              </div>
              <span className={`dropdown-arrow ${userDropdownOpen ? 'open' : ''}`}>
                ▼
              </span>
            </button>

            {userDropdownOpen && (
              <div className="user-dropdown">
                <div className="dropdown-item">
                  <span>👤</span>
                  <span>Profilis</span>
                </div>
                <div className="dropdown-item">
                  <span>⚙️</span>
                  <span>Nustatymai</span>
                </div>
                <div className="dropdown-divider"></div>
                <button className="dropdown-item logout" onClick={onLogout}>
                  <span>🚪</span>
                  <span>Atsijungti</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
